"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const types_1 = require("../types");
const BasicNode_1 = require("./BasicNode");
const validations_1 = require("../validations");
class ReportNode extends BasicNode_1.BasicNode {
  constructor(props) {
    if (!props) props = { type: types_1.NODE_TYPES.REPORT };
    if (props.type !== types_1.NODE_TYPES.REPORT)
      throw new Error("Invalid Node type");
    super(props);
  }
  deserialize(data) {
    let nodeData = data || this.getNodeData();
    let responseData = {
      type: types_1.NotificationType.NONE,
      slackConfig: "",
      recipient: "",
      reportOnlyOnData: true
    };
    if (!nodeData) return responseData;
    responseData = {
      type: nodeData.transport.type,
      slackConfig: nodeData.transport.options.slackConfig || "",
      recipient: nodeData.transport.options.recipient || "",
      reportOnlyOnData: nodeData.reportConditions.onlyOnData,
      extract: nodeData.extract
    };
    return responseData;
  }
  serialize(uiData) {
    let data = {
      reportConditions: {
        onlyOnData: uiData.reportOnlyOnData
      },
      extract: uiData.extract,
      transport: {
        type: uiData.type,
        options: {
          slackConfig: uiData.slackConfig,
          recipient: uiData.recipient
        }
      }
    };
    return data;
  }
  validate() {
    return new validations_1.ReportNodeValidation().validate(this);
  }
  setId(props) {
    this.setBasicNodeId(props);
  }
}
exports.ReportNode = ReportNode;
//# sourceMappingURL=ReportNode.js.map
